import { withStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';

import { primaryRed } from 'utils/color-styles';

export const PrimaryButton = withStyles({
  root: { background: primaryRed, color: 'white' },
})(Button);
